import React from "react";

/**
 * Global SVG filter that keys out ONLY near-white pixels (luminance > ~0.9).
 * All other colors — including the silver/light-blue "MAVERICKS" wordmark
 * and highlights on the M — are preserved fully opaque.
 *
 * Formula: alpha_out = 19 - (20/3)*(R + G + B)
 *   - luminance 1.00 (white)     -> alpha = -1  -> 0 (transparent)
 *   - luminance 0.95 (near-white)-> alpha =  0  -> 0 (transparent)
 *   - luminance 0.90             -> alpha =  1  -> 1 (opaque)
 *   - luminance 0.50 (silver)    -> alpha =  9  -> 1 (opaque)
 *   - luminance 0.00 (black)     -> alpha = 19  -> 1 (opaque)
 *
 * Only pixels with RGB avg ≥ 0.9 become transparent — narrow window that
 * captures the paper-white background and its anti-aliased edges without
 * touching any colored part of the logo.
 */
export default function LogoFilterDefs() {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      style={{ position: "absolute", width: 0, height: 0, overflow: "hidden" }}
    >
      <defs>
        <filter
          id="knockout-white"
          colorInterpolationFilters="sRGB"
          x="0"
          y="0"
          width="100%"
          height="100%"
        >
          <feColorMatrix
            in="SourceGraphic"
            type="matrix"
            values="1 0 0 0 0
                    0 1 0 0 0
                    0 0 1 0 0
                    -6.667 -6.667 -6.667 0 19"
          />
        </filter>
      </defs>
    </svg>
  );
}
